import React from 'react';
import PropTypes from 'prop-types';

import { getTime } from 'helpers';

import SortableColumn from 'components/Dashboard/SortableColumn';

export function RowHeader({}) {
    return (
        <div className="Header">
            <SortableColumn className="flex--1 item" name="id">
                ID
            </SortableColumn>
            <SortableColumn className="flex--2 item" name="qr_code">
                QR code
            </SortableColumn>
            <SortableColumn className="flex--2 item" name="client_group">
                Créateur
            </SortableColumn>
            <SortableColumn className="flex--2 item" name="created_by_nano_name">
                Jetson Nano
            </SortableColumn>
            <SortableColumn className="flex--2 item" name="created_at">
                Date de création
            </SortableColumn>
            <div className="flex--2 item sortable text-right">
                Autres analyses
            </div>
        </div>
    );
}

/**
 * Row Functional Component.
 */
export default function Row({data, onClick}) {
    let className = "Row";
    if (onClick) {
        className += " clickable";
    }

    return (
        <div className={className} onClick={() => onClick(data)}>
            <div className="flex--1">
                {data.id}
            </div>
            <div className="flex--2">
                {data.qr_code}
            </div>
            <div className="flex--2">
                {data.created_by_user && data.created_by_user.username}
            </div>
            <div className="flex--2">
                {data.created_by_nano && 
                    <span>
                        {data.created_by_nano && data.created_by_nano.name}
                    </span>
                }
            </div>
            <div className="flex--2">
                {getTime(data.created_at)}
            </div>
            <div className="flex--2 text-right">
            </div>
        </div>
    );
};

Row.displayName = 'Row';

Row.propTypes = {
};
